import { SlideFrame, SlideHeader, Reveal } from "@/components/presentation/slides/SlideFrame";
import { MediaPlaceholder } from "@/components/primitives/MediaPlaceholder";
import { Callout } from "@/components/primitives/Callout";

/**
 * 03 · ObservationSlide
 *
 * For market observations and problem framing. Headline + narrative on the
 * left, a comparison graphic on the right, and a single pulled-out insight
 * below the body to give the observation its punchline.
 */
export const ObservationSlide = ({
  eyebrow = "Observation",
  title = "What we noticed.",
  narrative = "A short, factual description of the pattern. Stay descriptive — interpretation comes in the insight below.",
  beforeLabel = "Today",
  afterLabel = "What it could be",
  insightTitle = "The insight",
  insightBody = "One quiet sentence that names why the observation matters.",
}) => {
  return (
    <SlideFrame testId="slide-observation">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="flex flex-col gap-6 lg:col-span-5">
          <SlideHeader eyebrow={eyebrow} title={title} lede={narrative} />
        </div>
        <Reveal delay={2} className="lg:col-span-7">
          <div
            data-testid="observation-comparison"
            className="grid grid-cols-1 gap-px overflow-hidden rounded-xl border border-border bg-border sm:grid-cols-2"
          >
            <div className="bg-card p-6">
              <div className="haevn-eyebrow mb-3">{beforeLabel}</div>
              <MediaPlaceholder
                kind="image"
                label="Status quo"
                ratio="4/3"
                testId="observation-before-visual"
              />
            </div>
            <div className="bg-card p-6">
              <div className="haevn-eyebrow mb-3">{afterLabel}</div>
              <MediaPlaceholder
                kind="image"
                label="Possible future"
                ratio="4/3"
                testId="observation-after-visual"
              />
            </div>
          </div>
        </Reveal>
      </div>
      <Reveal delay={3}>
        <Callout variant="note" title={insightTitle} testId="observation-insight">
          {insightBody}
        </Callout>
      </Reveal>
    </SlideFrame>
  );
};

export default ObservationSlide;
